import React from 'react'
import AnimateHeight from 'react-animate-height'
import classNames from 'classnames'

export function Accordion ({ list, title }) {
  if (list.length === 0) {
    return null
  }

  const [showSpecifications, setShowSpecifications] = React.useState(false)

  const accordionRows = list.map((item, index) => {
    return (
      <div key={index} className='mtt-accordion__headers'>
        <div className='mtt-accordion__header'>
          {item.label}
        </div>

        <div className='mtt-accordion__header'>
          {item.value}
        </div>
      </div>
    )
  })
  return (
    <div className={classNames('mtt-accordion', { active: showSpecifications })}>
      <div className='mtt-accordion__title-wrapper' onClick={() => setShowSpecifications(!showSpecifications)}>
        {title}
      </div>

      <AnimateHeight
        duration={500}
        height={showSpecifications ? 'auto' : 0}
      >
        <div className='mtt-accordion__content-wrapper'>
          {accordionRows}
        </div>
      </AnimateHeight>
    </div>
  )
}
